<div class="logo">
  <img class="image" [src]="img" />
  <div *ngIf="isDesktop" class="title typography-heading3-thin">
    {{ 'header.title' | translate }}
  </div>
</div>
